export default __webpack_public_path__ + "static/media/blanchard.965d6401.png";